import { createAction } from 'redux-actions';

export const NAME = 'CLIENT.VIDEO.SELECT';

export const selectVideo = createAction(NAME);




// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/select-video.js